export const getDataFromDataKey = (val, data_key) => {
  let keys = data_key.split(".");
  let value = val;
  keys.forEach((key) => {
    value = value[key];
  });
  return value;
};

export const getSumFromDataKey = (data, data_key) => {
  return data.reduce((acc, val) => {
    const value = getDataFromDataKey(val, data_key);
    return acc + (Number(value) ? Number(value) : 0);
  }, 0);
};
